import { Option } from '../types/common-types'
import { FiscalType, SoleTraderType } from '../enums/fiscalTypeEnum'

export const FiscalTypeValues: Option[] = [
  // {
  //   value: FiscalType.IP,
  //   label: {
  //     eng: 'Individual Entrepreneur (IP)',
  //     rus: 'Индивидуальный предприниматель (ИП)',
  //     kz: 'Жеке кәсіпкер (IP)',
  //   },
  // },
  {
    value: FiscalType.LLC,
    label: {
      eng: 'Limited Liability Company (LLC)',
      rus: 'Общество с ограниченной ответственностью (ООО)',
      kz: 'Жауапкершілігі шектеулі серіктестік (ЖШС)',
    },
  },
  {
    value: FiscalType.JSC,
    label: {
      eng: 'Joint Stock Company (JSC)',
      rus: 'Акционерное общество (АО)',
      kz: 'Акционерлік қоғам (АҚ)',
    },
  },
  {
    value: FiscalType.PJSC,
    label: {
      eng: 'Public Joint Stock Company (PJSC)',
      rus: 'Публичное акционерное общество (ПАО)',
      kz: 'Қоғамдық акционерлік қоғам (ЖАҚ)',
    },
  },
  // {
  //   value: '5',
  //   label: {
  //     eng: 'Closed Joint Stock Company (CJSC)',
  //     rus: 'Закрытое акционерное общество (ЗАО)',
  //     kz: 'Жабық акционерлік қоғам (ЖАҚ)',
  //   },
  // },
]
export const FiscalTypeValuesKz: Option[] = [
  {
    value: FiscalType.JSC,
    label: {
      eng: 'Joint Stock Company (JSC)',
      rus: 'Акционерное общество (АО)',
      kz: 'Акционерлік қоғам (АҚ)',
    },
  },
  {
    value: FiscalType.LLP,
    label: {
      eng: 'Limited Liability Partnership (LLP)',
      rus: 'Товарищество с ограниченной ответственностью (ТОО)',
      kz: 'Жауапкершілігі шектеулі серіктестік (ЖШС)',
    },
  },
]
export const IpTypeValuesKz: Option[] = [
  {
    value: FiscalType.IP,
    label: {
      eng: 'Individual Entrepreneur (IP)',
      rus: 'Индивидуальный предприниматель (ИП)',
      kz: 'Жеке кәсіпкер (IP)',
    },
  },
]
export const FiscalTypeValuesRom: Option[] = [
  {
    value: FiscalType.IP,
    label: {
      eng: 'Individual Entrepreneur (IP)',
      rus: 'Индивидуальный предприниматель (ИП)',
      kz: 'Жеке кәсіпкер (IP)',
    },
  },
  {
    value: FiscalType.LLC,
    label: {
      eng: 'Limited Liability Company (LLC)',
      rus: 'Общество с ограниченной ответственностью (ООО)',
      kz: 'Жауапкершілігі шектеулі серіктестік (ЖШС)',
    },
  },
]
export const FiscalTypeValuesKgz = [
  {
    value: FiscalType.IP,
    label: {
      eng: 'Individual Entrepreneur (IP)',
      rus: 'Индивидуальный предприниматель (ИП)',
      kz: 'Жеке кәсіпкер (IP)',
    },
  },
  {
    value: FiscalType.OsOO,
    label: {
      eng: 'Limited Liability Company (LLC)',
      rus: 'Общество с ограниченной ответственностью (ОсОО)',
      kz: 'Жауапкершілігі шектеулі серіктестік (ЖШС)',
    },
  },
]
export const soleTraderType = [
  {
    value: SoleTraderType.OldStyle,
    label: {
      eng: 'IP of the old type',
      rus: 'ИП старого образца',
      kz: 'Ескі типтегі IP',
    },
  },
  {
    value: SoleTraderType.NewStyle,
    label: {
      eng: 'IP of a new type',
      rus: 'ИП нового образца',
      kz: 'Жаңа түрдегі IP ',
    },
  },
]
